module.exports = __webpack_public_path__ + "img/practice-4.4f2b8e90.jpg";